/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Modifiedat1Inputs */

const de__field_modifiedat1 = /** @type {(inputs: _Field_Modifiedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert`)
};

/**

* @param {_Field_Modifiedat1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_modifiedat1 = /** @type {((inputs?: _Field_Modifiedat1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Modifiedat1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_modifiedat1(inputs)
});
export { _field_modifiedat1 as "_field_modifiedAt" }